import {STATUS_LOADING} from "../const";

export default {
    items: state => state.items,
    autocomplete: state => state.autocomplete,
    isLoading: state => state.status === STATUS_LOADING,
}